import {
  V2Button,
  V2Dialog,
  V2DialogContent,
  V2DialogFooter,
  V2DialogHeader,
} from "@stacklet/ui";
import { useNavigate } from "react-router";

type Action = "Remove" | "Delete";

interface Props {
  openDialog(arg: boolean): void;
  confirmDelete(): void;
  isDialogOpen: boolean;
  title: string;
  action?: Action;
  redirectPath?: string;
  deleteButtonTestId?: string;
  isPending?: boolean;
  pendingText?: string;
  onCancel?: () => void;
}

export function DeleteConfirmationDialog({
  title,
  openDialog,
  confirmDelete,
  isDialogOpen,
  action = "Delete",
  redirectPath,
  deleteButtonTestId = "confirmation-dialog-delete-button",
  isPending = false,
  pendingText,
  onCancel,
}: Props) {
  const navigate = useNavigate();
  const routeChange = () => {
    if (redirectPath) {
      navigate(redirectPath);
    }
  };

  return (
    <V2Dialog
      isOpen={isDialogOpen}
      onOpenChange={(open) => !open && openDialog(false)}
      size="md"
      isDismissable
    >
      <V2DialogHeader hideCloseButton>{`${action} ${title}`}</V2DialogHeader>
      <V2DialogContent>
        {`Are you sure you want to ${action.toLowerCase()} the ${title.toLowerCase()}? This operation is not recoverable.`}
      </V2DialogContent>
      <V2DialogFooter className="justify-between">
        <V2Button
          aria-label="cancel delete operation"
          isDisabled={isPending}
          onPress={() => {
            openDialog(false);
            onCancel?.();
          }}
          variant="tertiary"
        >
          Cancel
        </V2Button>
        <V2Button
          aria-label="confirm delete operation"
          data-testid={deleteButtonTestId}
          isDisabled={isPending}
          isPending={isPending}
          onPress={() => {
            confirmDelete();
            if (redirectPath) {
              routeChange();
            }
          }}
          pendingText={pendingText}
          variant="negative"
        >
          {action}
        </V2Button>
      </V2DialogFooter>
    </V2Dialog>
  );
}
